{
 "note": "Written by scripts/theme.mjs from theme/theme.mjs: change the theme there.",
 "id": "b4db62b02b9e",
 "tileId": "8f67b866aea7",
 "colours": {
  "room-hi": "#2b3531",
  "room": "#1a211e",
  "room-lo": "#111715",
  "shade": "#0d1210",
  "felt": "#1d4d38",
  "felt-dark": "#133828",
  "felt-lit-hi": "#2f7354",
  "felt-lit": "#255f45",
  "felt-lit-lo": "#1c4b35",
  "rim": "#25170c",
  "rim-lit": "#402f20",
  "panel": "#242d29",
  "sunken": "#181f1d",
  "ink": "#f4f1e8",
  "muted": "#b8c4bf",
  "bright": "#ffffff",
  "accent": "#e6b55d",
  "on-accent": "#1d2321",
  "ivory": "#dad6cc",
  "on-ivory": "#1d2321",
  "tile-face": "#f4f1e8",
  "tile-edge": "#cfc6ad",
  "umbra": "#000000",
  "plus": "#8bd48b",
  "minus": "#ff958b",
  "warn": "#ff9878",
  "win": "#ba3728",
  "on-win": "#f4f1e8",
  "win-ink": "#f75f4c",
  "red-five": "#c62828",
  "here": "#58c26b",
  "gone": "#6d7a86",
  "trace": "#255f45",
  "cls-best": "#5590e4",
  "cls-good": "#9dd6ec",
  "cls-inaccuracy": "#ffc299",
  "cls-mistake": "#ea6a64",
  "cls-blunder": "#ed4f8d",
  "medal-gold-hi": "#ffe08a",
  "medal-gold": "#e0a521",
  "on-medal-gold": "#2a1e00",
  "medal-silver": "#d5dbe3",
  "on-medal-silver": "#1c2530",
  "medal-bronze": "#c98a4f",
  "on-medal-bronze": "#24140a",
  "tile-ink": "#000000",
  "tile-white": "#ffffff",
  "tile-back": "#1d5754",
  "tile-red": "#b93c3c",
  "tile-red-five": "#d71e1e",
  "tile-green": "#004900",
  "tile-navy": "#000037",
  "tile-wind-a": "#19328c",
  "tile-wind-b": "#142896",
  "tile-haku": "#3d6fb8",
  "tile-diamond": "#e53935",
  "tile-diamond-edge": "#1b1b1b",
  "logo-red": "#b93c3c",
  "logo-felt": "#255f45"
 },
 "tiles": {
  "#000000": "#000000",
  "#ffffff": "#ffffff",
  "#f5f0eb": "#f4f1e8",
  "#ff3737": "#1d5754",
  "#b93c3c": "#b93c3c",
  "#d71e1e": "#d71e1e",
  "#004900": "#004900",
  "#000037": "#000037",
  "#19328c": "#19328c",
  "#142896": "#142896"
 }
}
